<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Modelo de Resposta</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Título:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="modelo_resposta.titulo" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Ordem:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="modelo_resposta.ordem" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Tipo Resposta:
                      </label>
                      <select v-model="modelo_resposta.tipo_resposta" class="form-control">
                        <option value="I">Imagem</option>
                        <option value="T">Texto</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3" v-if="modelo_resposta.tipo_resposta == 'I'">
                      <label for="Name">
                        <span class="required">*</span> Imagem:
                      </label>
                      <input autocomplete="new-password" type="file" id="path_imagem" class="form-control" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Modelo:
                      </label>
                      <v-select :options="modelos" :label="'titulo'" :reduce="modelo => modelo.id"
                        v-model="modelo_resposta.modelo_id" @input="getModelosPergunta"></v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Modelo da pergunta:
                      </label>
                      <v-select :options="modelos_pergunta" :label="'titulo'" id="modelo_pergunta"
                        :reduce="modelos_pergunta => modelos_pergunta.id" v-model="modelo_resposta.modelo_pergunta_id"></v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Aciona Identificador:
                      </label>
                      <v-select :options="modelos_pergunta" :label="'titulo'" id="aciona_identificador"
                        :reduce="modelos_pergunta => modelos_pergunta.id" v-model="modelo_resposta.aciona_identificador"></v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="password">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="modelo_resposta.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group">
                    <div class="block text-right">
                      <router-link to="/modelo_respostas" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      departments: [],
      change_password: true,
      modelo_resposta: {
        status: '1',
        aciona_identificador: "",
        modelo_pergunta_id: "",
      },
      modelos: [],
      modelos_pergunta: [],
      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let imagem = document.getElementById("path_imagem");

      fd.append("modelo_id", self.modelo_resposta.modelo_id);
      fd.append("modelo_pergunta_id", self.modelo_resposta.modelo_pergunta_id);
      fd.append("titulo", self.modelo_resposta.titulo);
      fd.append("ordem", self.modelo_resposta.ordem);
      fd.append("tipo_resposta", self.modelo_resposta.tipo_resposta);
      fd.append("aciona_identificador", self.modelo_resposta.aciona_identificador);
      fd.append("status", self.modelo_resposta.status);

      fd.append("_method", "POST");

      if (imagem && imagem.files[0]) {
        fd.append("path_imagem", imagem.files[0]);
      }

      if (self.modelo_resposta.id) {
        fd.append("id", self.modelo_resposta.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "modelo_respostas";
      let fd = self.makeFormData()

      if (self.modelo_resposta.id) {
        self.modelo_resposta._method = "PUT"
        api += "/" + self.modelo_resposta.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/modelo_respostas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.modelo_resposta.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.modelo_resposta.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.modelo_resposta.logradouro = self.endereco.logradouro;
            self.modelo_resposta.bairro = self.endereco.bairro;
            self.modelo_resposta.uf = self.endereco.uf;
            self.modelo_resposta.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getModeloResposta: function (id) {
      const self = this;
      const api = self.$store.state.api + "modelo_respostas/" + id + "?with[]=modelos&with[]=modelos_pergunta";

      axios
        .get(api)
        .then((response) => {
          self.modelo_resposta = response.data.data[0];
          self.getModelosPergunta(self.modelo_resposta.modelo_id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getModelos: function () {
      const self = this;
      const api = self.$store.state.api + "modelos";

      axios
        .get(api)
        .then((response) => {
          self.modelos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getModelosPergunta: function () {
      const self = this;
      const api = self.$store.state.api + "modelo_perguntas?modelo_id=" + self.modelo_resposta.modelo_id;

      axios
        .get(api)
        .then((response) => {
          self.modelos_pergunta = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },


  },
  mounted: function () {
    const self = this;

    self.getModelos();

    let id = self.$route.params.id;
    if (id) {
      self.getModeloResposta(id);

    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>